import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { useI18n } from '../i18n/I18nProvider';

export function LanguageSelector() {
  const { language, setLanguage, t } = useI18n();

  return (
    <TextField
      select
      size="small"
      label={t('language')}
      value={language}
      onChange={(event) => setLanguage(event.target.value as 'vi' | 'en')}
      sx={{ minWidth: 140 }}
    >
      <MenuItem value="vi">{t('vietnamese')}</MenuItem>
      <MenuItem value="en">{t('english')}</MenuItem>
    </TextField>
  );
}
